import React from "react";
import "./style.css";
import Logo from "../img//LogoSW.png";
import Navbar from 'react-bootstrap/Navbar';
import ModalIntroduceDeveloper from '../components/ModalIntroduceDeveloper'

const Footer = () => {
    return (

        <Navbar variant="dark" style={{ backgroundColor: "rgb(102, 102, 153, 0.90)", height: "auto" }} >
            <Navbar.Text className="row mx-auto col-12 justify-content-center" style={{ color: "black", fontSize: "18px", fontFamily: 'Noto Sans Thai' }}>
                <div className="col-12 col-md-7 text-md-end text-center ">
                    <b><img src={Logo} alt="Profile" className="rounded img-fluid" style={{ maxHeight: "30px" }} /> ศูนย์ซอฟต์แวร์กองทัพอากาศ</b>
                </div>
                <div className="col-12 col-md-5 text-md-start text-center">
                    <ModalIntroduceDeveloper />
                </div>



            </Navbar.Text>
        </Navbar>
    )
}

export default Footer